import React from 'react';
import styled from 'styled-components';

//#region Styled Components
const Content = styled.main`
  margin: 0;
  padding-bottom: 1rem;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: white;
  width: 100%;
  z-index: 5;
`;

const Input = styled.input`
  border: 1px solid var(--border-main);
  border-radius: 5px;
  padding: 1rem;
  margin: 1rem;
  font-size: 2em;
  width: 25rem;
  box-shadow: none;
  outline: none;
  transition: border-color 0.15s ease;

  &:hover,
  &:focus,
  &:active {
    border-color: var(--border-hover);
  }
`;

const Button = styled.button`
  border: 0;
  background-color: var(--button-main);
  color: white;
  font-size: 3rem;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover,
  &:focus,
  &:active {
    background-color: var(--button-hover);
    box-shadow: var(--box-shadow);
  }
`;

const SearchText = styled.h1`
  margin: 0;
  line-height: 1.15;
  font-size: 3rem;
  text-align: center;

  a {
    color: #0070f3;
    text-decoration: none;
  }

  a:hover,
  a:focus,
  a:active {
    text-decoration: underline;
  }
`;
//#endregion

const SearchInput = ({ changed, search, value }) => {
  const submitSearch = e => {
    if (e.which === 13) {
      e.preventDefault();
      search();
    }
  };

  return (
    <Content onKeyPress={submitSearch}>
      <Input
        value={value}
        onChange={e => changed(e.target.value)}
        tabIndex="1"
      />
      <SearchText>
        Search{' '}
        <Button onClick={search} tabIndex="2">
          CraigsList
        </Button>
      </SearchText>
    </Content>
  );
};

export default SearchInput;
